// extracted by mini-css-extract-plugin
export var container = "_ch-0";